module.exports = __webpack_public_path__ + "img/yijieshu.4ac31d2e.png";